<script>
import LegoModalLayout from "@/views/Helexium/Lego/LegoModalLayout.vue";
import LegoAuditoria from "@/components/Lego/LegoAuditoria.vue";
import LegoAdjuntos from "@/components/Lego/LegoAdjuntos.vue";
import LegoChat from "@/components/Lego/LegoChat.vue";

export default {
  components: {
    LegoModalLayout,
    LegoAuditoria,
    LegoAdjuntos,
    LegoChat,
  },
  props: {
    process: {
      type: String,
      required: true,
    },
    cardId: {
      type: String,
      required: true,
    },
  },
  async mounted() {
    if (this.cardId) {
      // Solo cargar la tarjeta si no existe o es diferente
      const currentCard = this.$store.state.lego.card;
      if (!currentCard || !currentCard.id || currentCard.id !== this.cardId) {
        await this.$store.dispatch("lego/getAndSetCard", this.cardId);
      }
    }
  },
  computed: {
    processLowercase() {
      return this.process.toLowerCase();
    },
  },
};
</script>

<template>
  <LegoModalLayout :title="process">
    <LegoAuditoria :cardId="cardId" v-if="processLowercase == 'validar'" />
    <LegoAdjuntos :cardId="cardId" v-else-if="processLowercase == 'adjuntos'" />
    <LegoChat :cardId="cardId" v-else-if="processLowercase == 'chat'" />
  </LegoModalLayout>
</template>
